import React from "react";
import useAuth from "../../../hooks/useAuth";
import Profile from "../Profile";
import AddEditBillingRates from "../../ProfileSettings/PersonalInformation/AddEditBillingRates";

const FreelancerProfile = ({ user, refetchMe, canAccessProfile = true }) => {
  const { auth, authRole } = useAuth();
  const isSelfView = auth?.user?.id === user?.id;

  const canSeeBillingRates = isSelfView && !user?.isCompanyOwner && !user?.isCompanyMember;

  return (
    <div className="grid grid-cols-1">
      <div>
        <Profile user={user} refetchMe={refetchMe} canAccessProfile={canAccessProfile} />

        {canSeeBillingRates && (
          <AddEditBillingRates
            readOnly
            billingRates={user?.billingRates}
            authRole={authRole}
            userData={user}
            refetchMe={refetchMe}
          />
        )}
      </div>
    </div>
  );
};

export default FreelancerProfile;
